import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Link, TextField } from '@mui/material';

import { SubmitButton } from 'components';
import { ROUTES } from 'consts';
import { useAuthForgotPasswordFormManager } from './auth-forgot-password-form.hook';

interface AuthForgotPasswordFormProps {
  next?: (data?: any) => void;
}

export const AuthForgotPasswordForm = ({ next }: AuthForgotPasswordFormProps) => {
  const navigate = useNavigate();
  const [{ formManager, loading_submit }] = useAuthForgotPasswordFormManager({ next });

  return (
    <form onSubmit={formManager.handleSubmit}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            onChange={formManager.handleChange('email')}
            error={!!(formManager.errors.email && formManager.touched.email)}
            helperText={formManager.touched.email ? formManager.errors.email : null}
          />
        </Grid>

        <Grid item xs={12}>
          <SubmitButton loading={loading_submit} label={'Send Email'} type="submit" sx={{ marginTop: 4 }} />
        </Grid>

        <Grid item xs={12}>
          <Link
            variant="subtitle2"
            onClick={() => navigate(`/${ROUTES.AUTH}/${ROUTES.AUTH_LOGIN}`)}
            sx={{ textDecoration: 'none', marginTop: 3, cursor: 'pointer', display: 'inline-flex' }}
          >
            Back to Login
          </Link>
        </Grid>
      </Grid>
    </form>
  );
};
